// extracted by mini-css-extract-plugin
export default {"ScrollHeader":"ScrollHeader_ScrollHeader__mJoaf"};